import { useEffect } from "react";
import { LoginCallback, useOktaAuth } from "@okta/okta-react";
import { Navigate, Route, Routes } from "react-router-dom";
import AppShell from "../components/AppShell";
import { DESIGN_API, GLOBAL_SETTINGS, ON_BOARD, OVERVIEW, REVIEW_SPEC, ROOT } from "./paths";
import { isOktaConfigured } from "./config/appConfig";
import {
  clearLoginRequiredAfterLogout,
  isLoginRequiredAfterLogout,
} from "./okta/logoutState";
import DesignApiPage from "../pages/DesignApiPage";
import GlobalSettingsPage from "../pages/GlobalSettingsPage";
import OnBoardPage from "../pages/OnBoardPage";
import OverviewPage from "../pages/OverviewPage";
import ReviewSpecPage from "../pages/ReviewSpecPage";
import LogoutCallback from "./okta/LogoutCallback";
import SecureRoute from "./okta/SecureRoute";

const RootRoute = () => {
  const { authState, oktaAuth } = useOktaAuth();
  const loginRequiredAfterLogout = isLoginRequiredAfterLogout();

  useEffect(() => {
    if (
      !isOktaConfigured ||
      !oktaAuth ||
      !authState ||
      authState.isPending ||
      authState.isAuthenticated
    ) {
      return;
    }

    if (loginRequiredAfterLogout) {
      clearLoginRequiredAfterLogout();
      oktaAuth.signInWithRedirect({
        prompt: "login",
      });
      return;
    }

    oktaAuth.signInWithRedirect();
  }, [authState, oktaAuth, loginRequiredAfterLogout]);

  if (!isOktaConfigured) {
    return <Navigate to={OVERVIEW} replace />;
  }

  if (!authState || authState.isPending) {
    return null;
  }

  if (authState.isAuthenticated) {
    return <Navigate to={OVERVIEW} replace />;
  }

  return null;
};

const AppRoutes = () => (
  <Routes>
    <Route path="/login/callback" element={<LoginCallback />} />
    <Route path="/logout/callback" element={<LogoutCallback />} />
    <Route path={ROOT} element={<RootRoute />} />
    <Route
      element={
        <SecureRoute>
          <AppShell />
        </SecureRoute>
      }
    >
      <Route path={OVERVIEW} element={<OverviewPage />} />
      <Route path={DESIGN_API} element={<DesignApiPage />} />
      <Route path={GLOBAL_SETTINGS} element={<GlobalSettingsPage />} />
      <Route path={ON_BOARD} element={<OnBoardPage />} />
      <Route path={REVIEW_SPEC} element={<ReviewSpecPage />} />
    </Route>
  </Routes>
);

export default AppRoutes;
